export default __webpack_public_path__ + "static/media/1319.95a35d01.png";